import React from 'react'
import RasterLayer from './RasterLayer'

const Bathymetry = () => {
  return (
    <RasterLayer
      id='BathymetryWavelet'
      authId='Bathymetry'
      />
  )
}

export default Bathymetry



// WEBPACK FOOTER //
// ./src/layers/BathymetryWavelet.js